import React from "react";
import './OrgPage.scss';
import LinkedIcon from '../../assets/svg/linked.svg';
import EmailIcon from '../../assets/svg/email.png'




const OrgNoSlider: React.FC = () => {

    return (
        <div className='no-slider-container'>
            <div className="organizator-card">
                <h2 className="org-small-title special-treatment">Glavni Organizator</h2>
                <img src={'/images/coretim/MilaJovic.jpeg'} alt="Glavni Organizator" className="org-car-img"/>
                <h2 className="org-small-title no-caps">Mila Jović</h2>
                <div className="org-social-links">
                <a href="https://www.linkedin.com/in/mila-jovic-2b544b314/" target="_blank" className="hover-it"><img src={LinkedIcon} alt="Linked icon" className="icons"/></a>
                <a href="https://mail.google.com/mail/?view=cm&to=mila.jovic.best@gmail.com" target="_blank" className="hover-it"> <img src={EmailIcon} alt="Email Icon" className="icons"/></a>                
               </div>
            </div>
            <div className="organizator-card">
                <h2 className="org-small-title special-treatment">Koordinator za odnose sa javnošću</h2>
                <img src={'/images/coretim/UrosKovacevic.jpeg'} alt="PR" className="org-car-img"/>
                <h2 className="org-small-title no-caps">Uroš Kovačević</h2>
                <div className="org-social-links">
                <a href="https://www.linkedin.com/in/uro%C5%A1-kova%C4%8Devi%C4%87-2509b43b0/" target="_blank" className="hover-it"><img src={LinkedIcon} alt="Linked icon" className="icons"/></a>
                <a href="https://mail.google.com/mail/?view=cm&to=uros.kovacevic.best@gmail.com" target="_blank" className="hover-it"> <img src={EmailIcon} alt="Email Icon" className="icons"/></a>                
                </div>  
                </div>
            <div className="organizator-card">
                <h2 className="org-small-title special-treatment">Koordinator Seminara</h2>
                <img src={'/images/coretim/AndjelaMatic.jpeg'} alt="KS" className="org-car-img"/>
                <h2 className="org-small-title no-caps">Anđela Matić</h2>
                <div className="org-social-links">
                <a href="https://www.linkedin.com/company/best-belgrade/" target="_blank" className="hover-it"><img src={LinkedIcon} alt="Linked icon" className="icons"/></a>
                <a href="https://mail.google.com/mail/?view=cm&to=andjela.matic.best@gmail.com" target="_blank" className="hover-it"> <img src={EmailIcon} alt="Email Icon" className="icons"/></a>                               
                </div>
            </div>
            <div className="organizator-card">
                <h2 className="org-small-title special-treatment">Koordinator za Logistiku</h2>
                <img src={'/images/coretim/VasilijePetrovic.jpeg'} alt="LOG" className="org-car-img"/>
                <h2 className="org-small-title no-caps">Vasilije Petrović</h2>
                <div className="org-social-links">
                <a href="https://www.linkedin.com/company/best-belgrade/" target="_blank" className="hover-it"><img src={LinkedIcon} alt="Linked icon" className="icons"/></a>
                <a href="https://mail.google.com/mail/?view=cm&to=vasilije.petrovic.best@gmail.com" target="_blank" className="hover-it"> <img src={EmailIcon} alt="Email Icon" className="icons"/></a>                
           
                </div>
            </div>
            <div className="organizator-card">
                <h2 className="org-small-title special-treatment">Koordinator za odnose sa kompanijama</h2>
                <img src={'/images/coretim/LukaRistic.jpeg'} alt="FR" className="org-car-img"/>
                <h2 className="org-small-title no-caps">Luka Ristić</h2>
                <div className="org-social-links">
                <a href="https://www.linkedin.com/in/luka-ristic-52316a3b7/" target="_blank" className="hover-it"><img src={LinkedIcon} alt="Linked icon" className="icons"/></a>
                <a href="https://mail.google.com/mail/?view=cm&to=luka.ristic.best@gmail.com" target="_blank" className="hover-it"> <img src={EmailIcon} alt="Email Icon" className="icons"/></a>                
                </div>
            </div>
            <div className="organizator-card">
                <h2 className="org-small-title special-treatment">Koordinator za dizajn</h2>
                <img src={'/images/coretim/KristinaDivac.jpeg'} alt="PUB" className="org-car-img"/>
                <h2 className="org-small-title no-caps">Kristina Divac</h2>
                <div className="org-social-links">
                <a href="https://www.linkedin.com/in/kristina-divac-96a4603b3/" target="_blank" className="hover-it"><img src={LinkedIcon} alt="Linked icon" className="icons"/></a>
                <a href="https://mail.google.com/mail/?view=cm&to=kristina.divac.best@gmail.com" target="_blank" className="hover-it"> <img src={EmailIcon} alt="Email Icon" className="icons"/></a>                
                </div>
            </div>
            
        </div>
    )

}

export default OrgNoSlider;